<script setup>

import Checkbox from '@/Components/Checkbox.vue';

</script>

<template>
	<div class="checkboxes">
		<div class="w-100 d-flex justify-content-between mb-2 mt-3">
				<span class="font-semibold text-small">Valoare</span>
				<span class="font-semibold text-small">Cantitate</span>
		</div>
		<div class="form-group d-flex pb-1" :class="{ 'd-none' : option.product_count == 0 }" v-for="(option, key) in attribute.options">

			<Checkbox :value="null"
				:id="option.id"
				:checked="selected_options.includes(parseInt(option.id))"
				@update:checked="updateChecked($event, option.id)">
			</Checkbox>

			<label :for="option.id" :dusk="'filter_attribute_option_' + option.translation.replaceAll(' ', '_')" class="d-flex justify-content-between w-100" :class="{ 'disabled' : option.product_count == 0 }">
				<span>{{option.translation || 'NA'}}</span>
				<span class="w-25px text-end">{{option.product_count}}</span>
			</label>

		</div>
	</div>
</template>

<script>
export default {
	name: "CheckboxFilter",
	props : [
		'attribute',
		'selected_options',
	],
	methods : {

		updateChecked(checked, option_id){

			const action = checked ? 'addItem' : 'removeItem';

			this.$emit(action, {
				attribute_id : this.attribute.id,
				option_id : option_id
			});

		}

	}
}
</script>